import { Component, Input } from '@angular/core';
import { ProvidersService } from 'fccore2';
import { Sysappbuttons } from 'fccore2';
import { FcinputComponent } from '../fcinput';
import { FCSIZE } from '../fc';
import { Fcapp } from 'fccore2';
import { ICellRendererParams, IAfterGuiAttachedParams } from 'ag-grid-community';
/**
 * fc-tlblistitemåè¡¨æç»å·¥å·æ 
 * 
 * åè¡¨æç»å·¥å·æ ç»ä»¶ã
 * 
 * åè¡¨æç»æé®ï¼é¢è§ãä¿®æ¹ã
 *
 */
@Component({
    selector: 'fc-tlblistitem',
    template: `
    <div *ngIf="fcMode==='button'" class="fc-tlblistitem" 
    [ngClass] = "{'fc-tlblistitem-small':fcSize === 'small','fc-tlblistitem-default':fcSize === 'default','fc-tlblistitem-large':fcSize === 'large'}">
        <fc-button  *ngFor="let btn of fcButtons" [fcToolTip]="btn.HELP||btn.BTNNAME||''" [fcLabel]="btn.BTNNAME" (click)="_event(btn.ACTCODE,btn)" [fcSize]="fcSize" [fcDisableds]="fcDisableds"></fc-button>
    </div>
    <div *ngIf="fcMode==='text'" class="fc-tlblistitem" [ngClass] = "{'fc-tlblistitem-small':fcSize === 'small','fc-tlblistitem-default':fcSize === 'default','fc-tlblistitem-large':fcSize === 'large'}">
        <a class="text" [title]="btn.HELP||btn.BTNNAME||''" *ngFor="let btn of fcButtons" (click)="_event(btn.ACTCODE,btn)">
            {{btn.BTNNAME}}
        </a>
    </div>
    `,
    styles: [`
        .fc-tlblist{
           text-align: center;
        }
        .text {
           font-size:12px;
           color:#108ee9;
           position:relative;
           margin-right:3px;
        }
        .text:after{
            content:'|';
            position:absolute;
            right:-2px;
            top:-2px;
            color:#cccccc;
            font-weight:lighter;
        }
        .text:last-child{
            margin-right:0;
        }
        .text:last-child:after{
            content:'';
        }
    `]
})
export class FctlblistitemComponent extends FcinputComponent {
    // æ°æ®åå®¹ç¬¦åå¨æäºèå´çæ¶åæ¾ç¤ºæäºæä½æé®ï¼ä¸ç¬¦ååä¸æ¾ç¤ºï¼
    // å·ä½å®æ½æ¹æ¡ä¸ºå¨ç»ä»¶fclistdataç»ä»¶ä¸­å¢å æ°å±æ§ï¼
    // fcViewActionStrategy="[{FIELDCODE:'STATUS',FIELDNOSHOWVALUE:'N',FIELDVALUE:'èµ·è',NOSHOWBUTTONS:[],BUTTONS:['listAdd','listDelete','listView',]}]"
    @Input()
    fcViewActionStrategy: string;
    viewAction: any[];
    // è·åæææä¸å¡ååçæé®
    @Input()
    fcBustype: string;
    params: any;
    /** æé®æ¯å¦ç¦ç¨ */
    @Input()
    fcDisableds: string;
    @Input()
    fcAppid: string;
    @Input()
    fcApp: Fcapp;
    @Input()
    fcButtons: Sysappbuttons[];
    @Input()
    fcLayout: string;
    /** æ¾ç¤ºæ¨¡å¼ */
    @Input()
    fcMode: string = "text";
    constructor(public provider: ProvidersService) {
        super(provider, 'fc-tlblistitem');
    }
    refresh(params: any): boolean {
        return false;
    }
    agInit(params: ICellRendererParams): void {
        this.params = params;
        if (this.params.value) {
            this.fcApp = params.value.parentComponent.fcApp;
            this.fcAppid = params.value.parentComponent.fcAppid;
            this.fcBustype = params.value.parentComponent.fcBustype;
            this.fcSize = FCSIZE.small;
            this.fcViewActionStrategy = params.value.parentComponent.fcViewActionStrategy;
            this._afterParentInit();
        }
    }
    afterGuiAttached?(params?: IAfterGuiAttachedParams): void {
    }
    _afterParentInit() {
        this.viewAction = [];
        if (this.fcViewActionStrategy) {
            try {
                this.viewAction = JSON.parse(this.fcViewActionStrategy);
            } catch {
                this.logService.error('æé®æ¾ç¤ºç­ç¥å¼å¼å¸¸ï¼è¯·åèï¼[{"FIELDCODE":"STATUS","FIELDVALUE":"èµ·è","BUTTONS":["listAdd","listDelete","listView"]}]æ ¼å¼');
            }
        }
        if (this.fcButtons === undefined) {
            if (this.fcAppid === undefined && this.fcApp === undefined) {
                throw new Error("ç¼ºå°å·¥å·æ ç»ä»¶");
            }
            let buttons = this.appService.getListButtonsByAppid(this.fcAppid);
            if (this.fcBustype) {
                buttons = buttons.filter(btn => btn.BUSTYPE === this.fcBustype);
            }
            if (this.fcViewActionStrategy) {
                // å¤çå¼
                let actions = "";
                let noactions = "";
                this.viewAction.forEach(view => {
                    const value = this.params.data[view.FIELDCODE];
                    if (value === view.FIELDVALUE
                        || (view.FIELDVALUE === 'isnull' && (value === undefined || value === null || value === '')
                            || (view.FIELDVALUE === 'isnotnull' && (value !== null && value !== undefined && value !== '')))) {
                        if (view.BUTTONS) {
                            actions += view.BUTTONS.join(",");
                        }
                    }
                    if (value === view.FIELDNOSHOWVALUE) {
                        view.NOSHOWBUTTONS.forEach(btn => {
                            noactions += btn + ",";
                        });
                    }
                });
                this.fcButtons = buttons.filter(btn => {
                    // ä¸åè®¸æ¾ç¤ºç­ç¥
                    if (noactions !== "" && noactions.indexOf(btn.ACTCODE) !== -1) {
                        return false;
                    }
                    // ç­ç¥
                    if (actions !== "") {
                        if (actions.indexOf(btn.ACTCODE) === -1) {
                            return false;
                        } else {
                            return true;
                        }
                    } else {
                        return true;
                    }
                });
            } else {
                this.fcButtons = buttons;
            }
        }
        if (this.fcLayout === undefined) {
            this.fcLayout = ToolbarListitemLayout.CENTER;
        }
    }
    /**
     * åä¸¤ç§æåµï¼ååµå°agridçå¤çæ¹å¼åä¼åéäºä»¶å°gridä¸­ãéè¿gridåçäºä»¶ã
     * @param eventName äºä»¶åç§°
     * @param btn æé®è¯¦æ
     */
    _event(eventName: string, btn: Sysappbuttons) {
        if (this.params) {
            const parent = this.params.value.parentComponent;
            this.params.ACTION = eventName;
            parent._doAction(this.params);
        }
        this.event(eventName, btn);
    }
}
export const ToolbarListitemLayout = {
    LEFT: "left",
    CENTER: "center",
    RIGHT: "right"
}
export const ToolbarListitemAction = {
    NEXT: "next",
    PREV: "prev",
    LISTEDIT: "listOneEdit",//åè¡¨æç»ä¿®æ¹
    LISTONEDETELE: 'listOneDelete',//åè¡¨æç»å é¤
    LISTONEVIEW: "listOneView"//åè¡¨æç»é¢è§
}
